<template>
  <q-item-section :avatar="avatar">
    <slot />
  </q-item-section>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'CItemSection',
  props: {
    avatar: Boolean,
  },
});
</script>

<style lang="scss" scoped></style>
